import { jsx as _jsx } from "react/jsx-runtime";
import { useFetch } from '@rad/hooks';
import Dropdown from '@rad/components/inputs/dropdown';
import { fetchCommunities } from '../../../common/network/system';
// Its own component so the listing is only fetched where it is shown. Staff reach this on the root
// host, and the endpoint behind it wants the same system-districts right that puts them there.
const TourCommunityField = (props) => {
    const [communitiesPromise] = useFetch(fetchCommunities);
    return (_jsx(Dropdown, { options: communitiesPromise, optionKey: opt => opt.id, optionLabel: opt => opt.title || opt.subdomain, value: props.value, onChange: props.onChange, invalid: props.invalid, label: "Community", required: true }));
};
export default TourCommunityField;
